module.exports = __webpack_public_path__ + "static/media/hofvijver.7376902c.jpg";